<template>
	<a
		v-if="campaignEnabled"
		:href="kitUrl"
		@click="trackClick"
		class="w-full bg-[#2f3f41] text-white relative overflow-hidden group flex print:hidden"
		aria-label="Get the free Worship Together starter kit"
	>
		<div class="absolute inset-0 opacity-[0.38] pointer-events-none">
			<!-- Site-wide: uses a brand illustration no page banner uses, so the footer never
			     repeats the banner sitting further up the same page. -->
			<img src="/images/wt-art-fellowship-left.jpg" class="w-full h-full object-cover object-center" alt="" />
		</div>
		<div class="absolute inset-0 opacity-30 mix-blend-screen pointer-events-none"
			style="background-image:
				radial-gradient(circle at 18% 50%, rgba(78,111,112,0.45), transparent 55%),
				radial-gradient(circle at 82% 50%, rgba(220,174,99,0.25), transparent 55%);" />
		<div class="absolute inset-0 bg-gradient-to-r from-[#2f3f41] via-[#2f3f41]/85 to-[#2f3f41] pointer-events-none" />

		<div class="relative w-full max-w-6xl mx-auto px-4 sm:px-8 py-3 md:py-2.5 flex flex-col sm:flex-row items-center justify-center sm:justify-between gap-3 sm:gap-6">
			<div class="flex items-center gap-3 text-center sm:text-left">
				<img
					src="/images/wt-brand-logo.png"
					alt=""
					class="w-9 h-9 shrink-0 object-contain drop-shadow-md hidden sm:block"
				/>
				<div class="leading-tight">
					<div class="text-[9px] font-semibold uppercase tracking-[0.22em] text-[#dcae63]">
						We Worship Together
					</div>
					<div class="text-sm md:text-base font-serif">
						<span class="font-bold">Worship together as a family.</span>
						<span class="hidden md:inline italic text-white/70">
							&nbsp;— a free starter kit for this Sunday.
						</span>
					</div>
				</div>
			</div>
			<span
				class="shrink-0 inline-flex items-center gap-2 px-6 py-2 rounded-full bg-[#cc9d4f] text-white text-xs font-semibold tracking-wide shadow-md transition-all group-hover:bg-[#b98b44] group-hover:shadow-lg"
			>
				Get the free kit
				<i class="fas fa-arrow-right text-xs transition-transform group-hover:translate-x-0.5" />
			</span>
		</div>
	</a>
</template>

<script>
import createCampaignElementMixin from '../../helpers/campaignElementMixin'

const KIT_PATH = '/worship-together'
const UTM = 'utm_source=cfl-site&utm_medium=site-footer&utm_campaign=worship-together&utm_content=global-footer'

export default {
	mixins: [createCampaignElementMixin('footer-cta')],
	computed: {
		kitUrl() {
			return `${KIT_PATH}?${UTM}`
		},
	},
	mounted() {
		if (this.campaignEnabled) this.trackCampaignImpression()
	},
	watch: {
		campaignEnabled(v) {
			if (v) this.trackCampaignImpression()
		},
	},
	methods: {
		trackClick() {
			this.trackCampaignClick({ link_url: this.kitUrl })
			try {
				if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
					window.gtag('event', 'family_worship_kit_footer_click', {
						event_category: 'engagement',
						event_label: 'site-footer',
						link_url: this.kitUrl,
					})
				}
			} catch {}
		},
	},
}
</script>
